export const LOCAL_STORAGE_TRADER_SETTINGS_KEY = 'lyra-trader-settings'
export const LOCAL_STORAGE_SESSION_KEY = 'session-key'
export const LOCAL_STORAGE_SUBACCOUNT_ID_KEY = 'subaccount-id'
export const LOCAL_STORAGE_ANNOUNCEMENTS_KEY = 'announcements'
export const LOCAL_STORAGE_BLOCKED_KEY = 'blocked-popup'
